import ProductsPage from "../ProductsPage/ProductsPage";

const PrototypesPage = () => {
    const productType = 0;

    return <ProductsPage productType={productType} />;
};

export default PrototypesPage;
